class GiftCardsAppConfig {
    constructor (private GiftCardsAppConstants: GiftCardsAppConstant,
        private $translateProvider: angular.translate.ITranslateProvider,
        private localStorageServiceProvider: angular.local.storage.ILocalStorageServiceProvider,
        private $httpProvider: ng.IHttpProvider,
        private uiSelectConfig: angular.ui.select.ISelectConfig,
        private tmhDynamicLocaleProvider: any) {
        uiSelectConfig.theme = 'bootstrap';
    }
    active = ():void => {
        //Initialize the translation filter provider
        this.$translateProvider.useStaticFilesLoader( { files: [{ prefix: this.GiftCardsAppConstants.i18nRoute, suffix: '.json' }, { prefix: this.GiftCardsAppConstants.generalI18nRoute, suffix: '.json' }] });//{ prefix: GiftCardsAppConstants.generalI18nRoute, suffix: '.json' });
        this.$translateProvider.useSanitizeValueStrategy('escaped');
        this.tmhDynamicLocaleProvider.localeLocationPattern(this.GiftCardsAppConstants.localeRoute + '/locale_{{locale}}.js');
        //Initialize the local storage provider
        this.localStorageServiceProvider.setPrefix('ib-gift-cards-app');
        this.localStorageServiceProvider.setStorageType('sessionStorage');
        this.$httpProvider.interceptors.push('IbHttpInterceptor');
        this.$httpProvider.defaults.withCredentials = true;
    };
    $onInit = this.active();
}
GiftCardsAppConfig.$inject = ['GiftCardsAppConstants', '$translateProvider', 'localStorageServiceProvider', '$httpProvider', 'uiSelectConfig', 'tmhDynamicLocaleProvider'];
try {
    angular.module('ib-gift-cards-app').config(GiftCardsAppConfig);
} catch (error) {
    const mod = angular.module('ib-gift-cards-app', []);
    mod.config(GiftCardsAppConfig);
}
